import create from './create';
import info from './info';
import deleteQualificationInfo from './delete';
import update from './update';
import list from './list';
import industryList from './industryList';

export default {
    create,
    info,
    deleteQualificationInfo,
    update,
    industryList,
    list
};

export interface QualificationInfo {
    code?: string;
    endTime?: string;
    imageUrl?: string;
    industry?: string;
    name?: string;
    startTime?: string;
    imageLogId?: string;
}



// WEBPACK FOOTER //
// ./src/api/systemManage/qualification/index.ts